import "./NoAccessMessage.css";

function NoAccessMessage({ area = "this page" }) {
    return (
        <div className="no-access-message">
            <i className="fas fa-lock no-access-message_icon"></i>
            <div className="no-access-message_title">You don't have access to {area}</div>
            <div className="no-access-message_hint">Ask an administrator to grant you the required role.</div>
        </div>
    );
}

export default NoAccessMessage;
